import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { Children } from "react";
import Icon from "../../../../../base/icons/icon/index.js";
import { InnerMarkdownHTML } from "../../../../../base/text/inner-markdown-HTML/index.js";
import * as S from "./styled.js";
export const BenefitsCardDesktop = ({ title , items =[] , className  })=>{
    const classTablet = classNames({
        'is-tablet': className?.includes('is-tablet')
    });
    if (!items.length) return null;
    const renderTitle = title && /*#__PURE__*/ _jsxs(S.BenefitsCardTitle, {
        className: classNames({
            'is-tablet': classTablet
        }),
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                className: "nico-circle-check"
            }),
            /*#__PURE__*/ _jsx(InnerMarkdownHTML, {
                content: title
            })
        ]
    });
    return /*#__PURE__*/ _jsxs(S.BenefitsCardWrapper, {
        className: classNames({
            className: !!className,
            'is-tablet': classTablet
        }),
        "data-testid": "BenefitsCard",
        children: [
            renderTitle,
            /*#__PURE__*/ _jsx(S.Content, {
                className: classNames({
                    'benefits-card-content': true,
                    'is-tablet': classTablet
                }),
                children: classTablet ? Children.toArray(items.map((item)=>/*#__PURE__*/ _jsxs(S.Items, {
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                className: "nico-check"
                            }),
                            " ",
                            /*#__PURE__*/ _jsx(InnerMarkdownHTML, {
                                content: item
                            })
                        ]
                    }))) : Children.toArray(items.map((item)=>/*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ _jsx(InnerMarkdownHTML, {
                            content: item
                        })
                    })))
            })
        ]
    });
};
export default BenefitsCardDesktop;

//# sourceMappingURL=index.js.map